export class Hata {
  hataKodu: any;
  hataDetayi: any;
}
